'use strict';

import qs from 'qs';

export const filterState = (state, depth = 0) => {
	const filtered = {};
	const keys = Object.keys(state);
	
	for (let key of keys) {
		let value = state[key];
		if (depth < 2 && `object` === typeof value) {
			value = filterState(value, depth + 1);
		}
		
		if (false === value || `` === value || null === value || undefined === value) {
			continue;
		}
		
		if (`object` === typeof value && ! Object.keys(value).length) {
			continue;
		}
		
		if (Array.isArray(value) && ! value.length) {
			continue;
		}
		
		filtered[key] = value;
	}
	
	return filtered;
};

export const createURL = state => `?${ qs.stringify(filterState(state), { allowDots: false }) }`;

export const searchStateToUrl = (location, searchState) => {
	const url = searchState
		? `${ location.pathname }${ createURL(searchState) }`
		: '';
	
	return url;
};

export const urlToSearchState = location => {
	const state = qs.parse(location.search.slice(1), {
		allowDots: false,
		decoder(value) {
			if (/^(\d+|\d*\.\d+)$/.test(value)) {
				return parseFloat(value);
			}
			
			const keywords = {
				true: true,
				false: false,
				null: null,
				undefined: undefined,
			};
			
			if (value in keywords) {
				return keywords[value];
			}
			
			try {
				return decodeURIComponent(value.replace(/\+/g, ' '));
			} catch {
				return value;
			}
		}
	});
	
	if (! ('page' in state)) {
		state.page = 1;
	}
	
	if (! ('refinementList' in state)) {
		state.refinementList = {
			"category": '',
			"approvals.generic_name": [],
		};
	}
	
	return state;
};
